import { FILE_SIZE as BASE_FILE_SIZE, MEGABYTE } from 'components/Upload';

const TREEZOR_MAX_SIZE = 4.5 * MEGABYTE;

export const FILE_SIZE: typeof BASE_FILE_SIZE = {
  ...BASE_FILE_SIZE,
  DEFAULT: TREEZOR_MAX_SIZE,
};
